export async function handleBlobError(
  error: any,
  showMessage: (title: string, error: any) => void
): Promise<void> {
  if (error.response?.data instanceof Blob && error.response.data.type === "application/json") {
    try {
      const text = await error.response.data.text();
      const errorJson = JSON.parse(text);

      // Inject the parsed JSON back into error.response.data
      error.response.data = errorJson;

      showMessage(errorJson.message || "An unexpected error occurred.", error);
    } catch (parseError) {
      showMessage("An unexpected error occurred (could not parse error blob).", error);
    }
  } else {
    showMessage("Download failed due to unknown error.", error);
  }
}
